import { SuperAdminConstants } from '../../../_constants';

const initialState = { removeAnalyticsActiveBatchesLoading: true, data: '', error: false };

export function removeAnalyticsActiveBatches(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_REMOVE_ANALYTICS_ACTIVE_BATCHES:
            return {
                removeAnalyticsActiveBatchesLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_REMOVE_ANALYTICS_ACTIVE_BATCHES:
            return {
                removeAnalyticsActiveBatchesLoading: false,
                data: action.removeAnalyticsActiveBatches,
                error: false
            };
        case SuperAdminConstants.REMOVE_ANALYTICS_ACTIVE_BATCHES_ERROR:
            return {
                removeAnalyticsActiveBatchesLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageBatches/removeAnalyticsActiveBatches.reducer.js